import http from "../utils/http"; // getFromSessionStorage // getFromLocalStorage,

export class DentalClinicService {
  constructor(config = {}) {
    this.lab_job_categorie_id = config.lab_job_categorie_id;
  }

  static async saveEmployeeLiquidation(reg) {
    return (await http.post("api/dental/liquidation-percent", reg)).data;
  }

  static async getProductcategories(params) {
    return (await http.get("api/dental/products/categories", { params })).data;
  }

  static async getProformDetails(params) {
    return (await http.get("api/dental/proform-details", { params })).data;
  }

  static async getProformDetail(id) {
    return (await http.get(`api/dental/proform-details/${id}`)).data;
  }

  static async saveProformDetail(reg) {
    if (reg.id)
      return (await http.put(`api/dental/proform-details/${reg.id}`, reg)).data;
    else return (await http.post("api/dental/proform-details", reg)).data;
  }

  static async deleteProformDetail(id) {
    return (await http.delete(`api/dental/proform-details/${id}`)).data;
  }

  static async getClients(params) {
    return (await http.get("api/dental/clients", { params })).data;
  }

  static async getClient(id) {
    return (await http.get(`api/dental/clients/${id}`)).data;
  }

  static async saveClient(reg) {
    if (reg.id)
      return (await http.put(`api/dental/clients/${reg.id}`, reg)).data;
    else return (await http.post("api/dental/clients", reg)).data;
  }

  static async deleteClient(id) {
    return (await http.delete(`api/dental/clients/${id}`)).data;
  }

  static async getScheduleEmployeeBusyTime(params) {
    return (
      await http.get("api/service/schedule-times-next-busy-time", {
        params,
      })
    ).data;
  }

  static async getClientReport(params = {}) {
    return (await http.get("api/dental/reports/new-clients", { params })).data;
  }

  static async disableScheduleTime(reg) {
    return (await http.post("api/general/schedule-disable-times", reg)).data;
  }

  static async deleteSale(id) {
    return (await http.delete(`api/service/sales/${id}`)).data;
  }

  static async reqTreatmentDetaillabJob(reg) {
    return (
      await http.post("api/dental/treatment-plan-details/req-lab-job", reg)
    ).data;
  }

  static async payLaboratoryJobs(reg) {
    return (
      await http.post("api/dental/laboratory-jobs", {
        ...reg,
        to_pay: 1,
      })
    ).data;
  }

  static async deleteProform(id, reason, plan_id) {
    return (
      await http.delete(`api/dental/proforms/${id}`, {
        params: {
          reason,
          treatment_plan_id: plan_id,
        },
      })
    ).data;
  }

  static async getProformsReport(params) {
    return (await http.get("api/dental/proforms/report", { params })).data;
  }

  static async saveClientFileStatus(reg) {
    return (await http.post("api/clinic/client-files/changeStatus", reg)).data;
  }

  static async getAgenda(params) {
    return (await http.get("api/service/agenda", { params })).data;
  }

  /**
   *
   * QUOTES BEGIN
   *
   */
  static async getQuotes(params) {
    return (await http.get("api/dental/quotes", { params })).data;
  }

  static async getQuote(id) {
    return (await http.get(`api/dental/quotes/${id}`)).data;
  }

  static async saveQuote(reg) {
    if (reg.id) {
      return (await http.put(`api/dental/quotes/${reg.id}`, reg)).data;
    } else {
      return (await http.post("api/dental/quotes", reg)).data;
    }
  }

  static async deleteQuote(id) {
    return (await http.delete(`api/dental/quotes/${id}`)).data;
  }

  static async getProgramQuotes(params) {
    return (
      await http.get("api/dental/program-quotes", {
        params,
      })
    ).data;
  }

  static async saveOrthodonticPlan(reg) {
    return (await http.post("api/dental/orthodontic-plans", reg)).data;
  }

  static async setTreatmentDiscount(reg) {
    return (await http.post("api/dental/treatment-plans/set-discount", reg))
      .data;
  }

  static async getOrthodontic(params) {
    return (
      await http.get("api/dental/orthodontics", {
        params,
      })
    ).data;
  }

  static async getEmployeePayments(params) {
    return (
      await http.get("api/dental/employee-payments", {
        params,
      })
    ).data;
  }

  static async saveProgramQuote(reg) {
    if (!reg.id) {
      return (await http.post("api/dental/program-quotes", reg)).data;
    } else {
      return (await http.put(`api/dental/program-quotes/${reg.id}`, reg)).data;
    }
  }

  static async getOrthodonticPlan(params) {
    return (
      await http.get("api/dental/orthodontic-plans", {
        params,
      })
    ).data;
  }

  static async getTreatmentPlanDetails(params) {
    return (
      await http.get("api/dental/treatment-plan-details", {
        params,
      })
    ).data;
  }

  static async saveOrthodontic(reg) {
    if (!reg.id) {
      return (await http.post("api/dental/orthodontics", reg)).data;
    } else {
      return (await http.put("api/dental/orthodontics/" + reg.id, reg)).data;
    }
  }

  // static getOrthodonticHistory = async (client_id) => {
  //   return (await http.get("api/dental/orthodontics", {params: {client_id}})).data;
  // }

  static async payDebts(reg) {
    return (await http.post("api/service/financing-dues/to-pay", reg)).data;
  }

  static async returnTPPayment(reg) {
    return (
      await http.put(
        "api/dental/treatment-plans/" + reg.treatment_plan_id,
        reg,
        {
          params: {
            lets_return: 1,
          },
        }
      )
    ).data;
  }

  static async cancelSale(reg) {
    return (
      await http.post("api/dental/treatment-plans", reg, {
        params: {
          cancel_sale: 1,
        },
      })
    ).data;
  }

  static async transferTreatmentPayment(reg) {
    return (
      await http.put("api/dental/treatment-plans/" + reg.treatment_plan_id, reg)
    ).data;
  }

  static async getTreatmentHistory(params) {
    return (
      await http.get("api/service/treatment-plan-history", {
        params,
      })
    ).data;
  }

  static async putFinancing(reg) {
    return (await http.put("api/service/financings/" + reg.id, reg)).data;
  }

  static async getDebts(params) {
    return (
      await http.get("api/store/debts", {
        params,
      })
    ).data;
  }

  static async putFinancingDue(reg) {
    return (await http.put("api/service/financing-dues/" + reg.id, reg)).data;
  }

  static async saveFinancing(reg) {
    return (await http.post("api/service/financings", reg)).data;
  }

  static async getFinancing(id) {
    return (await http.get("api/service/financings/" + id)).data;
  }

  static async getFinancings(params) {
    return (
      await http.get("api/service/financings", {
        params,
      })
    ).data;
  }

  static async getFinancingDues(params) {
    return (
      await http.get("api/service/financing-dues", {
        params,
      })
    ).data;
  }

  static async payDebtsFromTreatmentPayment(reg) {
    return (
      await http.post("api/service/financing-dues", reg, {
        params: {
          from_treatment_payment: 1,
        },
      })
    ).data;
  }

  static async getQuoteComments(params) {
    return (
      await http.get("api/service/quote-comments", {
        params,
      })
    ).data;
  }

  static async saveEmployeePayment(reg) {
    return await http.put("api/dental/employee-payments/" + reg.id, reg);
  }

  static async setEmployeePaymentToPay(id, toPay) {
    return await http.put("api/general/employee-payments/" + id, {
      change_to_pay: 1,
      to_pay: toPay,
    });
  }

  static async saveQuoteComment(reg) {
    return (await http.post("api/service/quote-comments", reg)).data;
  }

  static async getEmployeeConfigs(params) {
    return (
      await http.get("api/dental/employee-config", {
        params,
      })
    ).data;
  }

  static async getEmployeeConfig(id) {
    return (await http.get("api/dental/employee-config/" + id)).data;
  }

  static async saveEmployeeConfig(reg) {
    return (await http.post("api/dental/employee-config", reg)).data;
  }

  static async getSupplierProducts(params) {
    params.categorie_id = this.lab_job_categorie_id;
    return (
      await http.get("api/logistic/supplier-products", {
        params,
      })
    ).data;
  }

  static async deleteSale(sale_id) {
    return (await http.delete(`api/service/sales/${sale_id}`)).data;
  }

  static async deleteTreatmentPlan(id, params) {
    return (
      await http.delete("api/dental/treatment-plans/" + id, {
        params,
      })
    ).data;
  }

  static async requestLaboratoryJob({
    employee_id,
    lab_job_id,
    comment,
  }) {
    return (
      await http.put("api/dental/laboratory-jobs/" + lab_job_id, {
        employee_id,
        comment,
        lets_req: 1,
      })
    ).data;
  }

  static async putLaboratoryJob(reg) {
    return (await http.put("api/dental/laboratory-jobs/" + reg.id, reg)).data;
  }

  static async putLaboratoryJobStatus({ list, status }) {
    return (
      await http.put("api/dental/laboratory-jobs/set-status", {
        list,
        status,
      })
    ).data;
  }

  static async saveTreatmentPlanDetail(reg) {
    if (!reg.id) {
      return (await http.post("api/dental/treatment-plan-details", reg)).data;
    } else {
      return (
        await http.put(`api/dental/treatment-plan-details/${reg.id}`, reg)
      ).data;
    }
  }

    static async saveComOdoToTreatment(reg) {
    return (
      await http.post("api/dental/treatment-plan-details", {
        from_com_odo: 1,
        ...reg,
      })
    ).data;
  }

  static async setTreatmentPlan(reg) {
    return (await http.put("api/dental/treatment-plans/" + reg.id, reg)).data;
  }

  static async saveProductStatus(reg) {
    return (await http.post("api/dental/product-states", reg)).data;
  }

  static async getProductStates(params) {
    return (
      await http.get("api/dental/product-states", {
        params,
      })
    ).data;
  }

  // static deleteProformDetail = async id => {
  //   return (await http.delete("api/dental/proform-details/" + id)).data;
  // };

  // static saveQuote = async reg => {
  //   if (!reg.id) {
  //     return (await http.post("api/service/quotes", reg)).data;
  //   } else {
  //     return (await http.put("api/service/quotes/" + reg.id, reg)).data;
  //   }
  // };

  static async inEvolutionTreatmentDetail(id) {
    return (
      await http.put("api/dental/treatment-plan-details/" + id, {
        inevolution: true,
      })
    ).data;
  }

  static async proformChangeDiscount(id, discount) {
    return (
      await http.put("api/dental/proforms/" + id, {
        discount,
        change_discount: 1,
      })
    ).data;
  }

  static async proformDetailChangeDiscount(id, discount) {
    return (
      await http.put("api/dental/proform-details/" + id, {
        discount,
        change_discount: 1,
      })
    ).data;
  }

  static async proformDetailChangePrice(id, price) {
    return (
      await http.put(
        "api/dental/proform-details/" + id,
        {
          price,
        },
        {
          params: {
            change_price: 1,
          },
        }
      )
    ).data;
  }

  static async setPriceTreatmentDetail(id, price) {
    return (
      await http.put("api/dental/treatment-plan-details/" + id, {
        setPrice: 1,
        price,
      })
    ).data;
  }

  static async setDiscountTreatmentDetail(id, discount) {
    return (
      await http.put("api/dental/treatment-plan-details/" + id, {
        discount,
        setDiscount: true,
      })
    ).data;
  }

  static async setMoneyToTreatment(
    client_id,
    money_code,
    treatment_plan_id,
    quantity
  ) {
    return (
      await http.put("api/dental/treatment-plans/" + treatment_plan_id, {
        client_id,
        money_code,
        quantity,
        add_payment: true,
      })
    ).data;
  }

  static async setTreatmentPlanDetail(args) {
    return (
      await http.put("api/dental/treatment-plan-details/" + args.id, args)
    ).data;
  }

  static async deleteTreatmentPlanDetail(id) {
    return (await http.delete("api/dental/treatment-plan-details/" + id)).data;
  }

  static async letsToPayTPD(reg) {
    return (await http.post("api/dental/treatment-plans/pay", reg)).data;
  }

  static async deleteOdontogramMenu(id) {
    return (await http.delete("api/dental/odontogram-menu/" + id)).data;
  }

  static async getOdontogramMenu(params) {
    // return (await getFromSessionStorage("api/dental/odontogram-menu", {
    //   params
    // })).data;
    return (await http.get("api/dental/odontogram-menu", { params })).data;
  }

  static async saveOdontogramMenu(reg) {
    if (!reg.id) {
      return (await http.post("api/dental/odontogram-menu", reg)).data;
    } else {
      return (await http.put("api/dental/odontogram-menu/" + reg.id, reg)).data;
    }
  }

  static async saveEvolutionTreatment(reg) {
    return (await http.put("api/dental/treatment-plans/evolution", reg)).data;
  }

  static async loadOdontogramToTreatment(reg) {
    return (await http.post("api/dental/treatment-plans/from-odo-id", reg))
      .data;
  }

  static async saveTreatmentPlan(reg) {
    if (!reg.id) {
      return (await http.post("api/dental/treatment-plans", reg)).data;
    } else {
      return (await http.put(`api/dental/treatment-plans/${reg.id}`, reg)).data;
    }
  }

  static async saveProformDetail(reg) {
    if (!reg.id) {
      return (await http.post("api/dental/proform-details", reg)).data;
    }
  }

  static async deleteProformItemByThId(th_id) {
    return (await http.delete("api/dental/proform-details/by-th-id/" + th_id))
      .data;
  }

  static async getTreatmentPlan(id, params) {
    return (
      await http.get("api/dental/treatment-plans/" + id, {
        params,
      })
    ).data;
  }

  static async getTreatmentPlans(params) {
    return (
      await http.get("api/dental/treatment-plans", {
        params,
      })
    ).data;
  }

  static async getProform(id) {
    return (await http.get("api/dental/proforms/" + id)).data;
  }

  static async getProforms(params) {
    return (
      await http.get("api/dental/proforms", {
        params,
      })
    ).data;
  }

  static async getTeethHistory(params) {
    return (
      await http.get("api/dental/teeth-history", {
        params,
      })
    ).data;
  }

  static async saveToothStatus(reg) {
    return (await http.post("api/dental/teeth-history", reg)).data;
  }

  static async deleteTeethHistory(id) {
    await http.delete("api/dental/teeth-history/" + id);
    return;
  }

  static async getPatientFiles(arg) {
    return (
      await http.get("api/clinic/client-files", {
        params: arg,
      })
    ).data;
  }

  static async saveClientFile(reg) {
    let body = new FormData();
    for (let name in reg) {
      body.append(name, reg[name]);
    }
    let requestOption = { headers: { "Content-Type": "multipart/form-data" } };
    return (await http.post("api/clinic/client-files", body, requestOption))
      .data;
  }

  static async deleteClientFile(id) {
    await http.delete("api/clinic/client-files/" + id);
    return;
  }

  static async saveProForm(reg) {
    if (!reg.id) {
      return (await http.post("api/dental/proforms", reg)).data;
    } else {
      return (await http.put(`api/dental/proforms/${reg.id}`, reg)).data;
    }
  }

  static async changePriceTeethHist(reg) {
    return (await http.put("api/dental/teeth-history/" + reg.id, reg)).data;
  }

  static async getReportProform(params) {
    return (await http.get(`api/dental/reports/proforms`, { params })).data;
  }

  static async deleteTreatmentPlanDetails(params) {
    return (await http.delete(`api/dental/treatment-plan-details/group`, { params })).data;
  }

  static async reportFinancingDues(params) {
    return (
      await http.get("api/service/financings/report-dues", {
        params,
      })
    ).data;
  }

  static async reactivateTreatmentPlan(id) {
    return DentalClinicService.saveTreatmentPlan({
      id,
      reactive: 1,
    });
  }

  static async getDisableScheduleTimes(params) {
    return (await http.get("api/general/schedule-disable-times", { params })).data;
  }

  static async getDisableScheduleTime(id) {
    return (await http.get(`api/general/schedule-disable-times/${id}`)).data;
  }

  static async saveDisableScheduleTime(reg) {
    if (reg.id === undefined || reg.id === null) {
      return (await http.post("api/general/schedule-disable-times", reg)).data;
    } else {
      return (await http.put(`api/general/schedule-disable-times/${reg.id}`, reg)).data;
    }
  }

  static async deleteDisableScheduleTime(id) {
    return (await http.delete(`api/general/schedule-disable-times/${id}`)).data;
  }

  static async getControl(params) {
    return (await http.get("api/dental/reports/control", { params })).data;
  }

  static async getControlRange(params) {
    return (await http.get("api/dental/reports/control-range", { params }))
      .data;
  }

  static async getControlByMonth(params) {
    return (await http.get("api/dental/reports/control-range", { params }))
      .data;
  }

  static async getResumeMonthly(params) {
    return (await http.get("api/dental/reports/resume-monthly", { params }))
      .data;
  }

  static async getLaboratoryJobs(params) {
    return (await http.get("api/dental/laboratory-jobs", { params })).data;
  }
  
  static async getLaboratoryJob(id) {
    return (await http.get(`api/dental/laboratory-jobs/${id}`)).data;
  }
  
  static async saveLaboratoryJob(reg) {
    if (reg.id === undefined || reg.id === null) {
      return (await http.post("api/dental/laboratory-jobs", reg)).data;
    } else {
      return (await http.put(`api/dental/laboratory-jobs/${reg.id}`, reg)).data;
    }
  }
  
  static async deleteLaboratoryJob(id) {
    return (await http.delete(`api/dental/laboratory-jobs/${id}`)).data;
  }
}

export default DentalClinicService;
